<script>
    import { mapActions, mapState } from 'vuex';
    import {getUrlParams} from "../../commonjs/utils/UrlHandler";
    import { selectPageInParentWindow } from "../../components/pagesbuilder/store/modules/pageUtils";
    import Vue from 'vue';
    import Vuex from 'vuex'
    import textSizesConfig from "../../author/pagesbuilder/components/global-styling/components/textSizesConfig";

    Vue.use(Vuex);
    Vue.config.performance = true;
    Vue.config.productionTip = false;
    Vue.config.silent = true;
    export default {
        created () {
            this.mainCreated();
        },
        computed: {
            ...mapState('siteTemplate', [
                'activeSiteTemplate'
            ]),
            ...mapState('pages', [
                'pageAdditionalData'
            ])
        },
        methods: {
            selectPageInParentWindow,
            ...mapActions('UiInteractions',[
                'setFullscreenStatus',
                'setViewportDimensions'
            ]),
            ...mapActions([
                'clearCurrentPageData'
            ]),
            ...mapActions('components',[
                'initComponentsManager'
            ]),
            ...mapActions('modalWindows',[
                'getLinksManagerData'
            ]),
            ...mapActions('pages',[
                'setInsertPageContentFlag',
                'getPageData',
                'setPageContext',
                'setPageData',
                'initializePageData'
            ]),
            ...mapActions('sections',[
                'initSectionsManager',
            ]),
            ...mapActions('siteTemplate',[
                'setCurrentSiteTemplate',
                'loadSiteTemplates',
                'loadActiveSiteTemplate',
            ]),
            ...mapActions('products' , [
                'loadProducts'
            ]),
            ...mapActions('elements' , [
                'initElementsManager'
            ]),
            ...mapActions('common' , [
                'getArticles'
            ]),
            mainCreated () {
                this.init();
                this.addWindowListeners();
                this.checkViewportDimensions();
            },
            addWindowListeners () {
                window.addEventListener("resize", this.onWindowResize);
            },
            onWindowResize() {
                this.checkViewportDimensions();
            },
            checkViewportDimensions () {
                this.setViewportDimensions({
                    width: window.getViewPortWidth(),
                    height: window.getViewPortHeight(),
                })
            },
            // init () {
            //     let urlParams = getUrlParams(document.location.href);
            //     //load products to setup store and interface editing tools
            //     this.loadProducts();
            //     this.getLinksManagerData();
            //     // this.getArticles();
            //
            //     console.log("INIT !!")
            //     this.loadSiteTemplates().then( () => {
            //         this.loadActiveSiteTemplate().then( () => {
            //             let args = this.getArgsFromUrl(urlParams);
            //             this.setCurrentSiteTemplate(args.site_template);
            //
            //             if (!args.site_template) {
            //                 args.site_template = this.activeSiteTemplate ? this.activeSiteTemplate : null;
            //             }
            //
            //             return this.getPageData(args);
            //         }).then( (pageData) => {
            //             this.selectPageInParentWindow({slug:pageData.slug,type:pageData.type,site_template:pageData.site_template });
            //             // this.setPageData(pageData);
            //             this.setPageContext(urlParams);//first load executes with url then context is set by pageData
            //             //flag to trigger section insertion by SectionsManager
            //             this.setInsertPageContentFlag(true);
            //             // this.selectPageInParentWindow( {...pageData,replaceState:true});
            //
            //             //we have to wait for the DOM to be inserted which doesn't happen in the same cycle
            //             this.$nextTick( () => {
            //                 let pageWrapper = document.querySelector("#pageContent");
            //                 this.initSectionsManager(pageWrapper);
            //                 this.initComponentsManager(pageWrapper);
            //                 this.initElementsManager(pageWrapper);
            //             });
            //         });
            //
            //     })
            //
            //
            // },
            getArgsFromUrl (urlParams) {

                let currentSiteTemplate =  urlParams.site_template || this.activeSiteTemplate;
                //when there's no 'type' url param it defaults to page
                if (!urlParams.type) {
                    urlParams.type = "page";
                }
                if (!urlParams.page) {
                    urlParams.page = document.location.pathname.replace("/pages/","");
                }

                return {
                    slug: urlParams.page,
                    type: urlParams.type,
                    site_template: currentSiteTemplate
                }

            },
        },
        watch : {

            'pageAdditionalData.textSizing': {
                immediate: true,
                deep: true,
                handler() {
                    let pageContent = document.querySelector("#pageContent");

                    // This is also loaded via mini.js for built in pages which does not have
                    // pageContent in the DOM
                    if (!pageContent) {
                        return;
                    }

                    if (this.pageAdditionalData && this.pageAdditionalData.textSizing) {
                        textSizesConfig.forEach((textSizingData) => {
                            if (this.pageAdditionalData.textSizing === textSizingData.key) {
                                pageContent.classList.add(textSizingData.pageContentClass);
                            } else {
                                pageContent.classList.remove(textSizingData.pageContentClass);
                            }
                        });
                    } else if (!this.pageAdditionalData.textSizing) {
                        textSizesConfig.forEach((textSizingData) => {
                            if (textSizingData.key === "normal") {
                                pageContent.classList.add(textSizingData.pageContentClass);
                            } else {
                                pageContent.classList.remove(textSizingData.pageContentClass);
                            }
                        });
                    }
                },
            },
        },
    }
</script>
